module.exports = __webpack_public_path__ + "img/picture_22.e3ebe3a9.png";